export default __webpack_public_path__ + "static/media/kycArtWhite.d4a74a7a.png";